export default __webpack_public_path__ + "static/media/snowuns.b57ca865.webp";